"use client";

import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { useEffect } from "react";

let awsRum: AwsRum | undefined;

// Expose a global function to record errors from error boundaries
declare global {
  interface Window {
    recordRumError?: (
      error: Error,
      errorInfo?: { componentStack?: string },
    ) => void;
  }
}

const AWSCloudWatchRealUserMointor = ({
  awsRegion,
  rumApplicationId,
  rumIdentityPoolId,
  stage,
}: {
  awsRegion?: string;
  rumApplicationId?: string;
  rumIdentityPoolId?: string;
  stage?: string;
}) => {
  useEffect(() => {
    if (stage === "prod") {
      return;
    }
    try {
      if (!rumApplicationId || !rumIdentityPoolId || !awsRegion) {
        console.error("AWS RUM configuration is missing");
        return;
      }

      const APPLICATION_VERSION = "1.0.0";

      const RUM_CONFIG: AwsRumConfig = {
        sessionSampleRate: 1,
        identityPoolId: rumIdentityPoolId,
        endpoint: `https://dataplane.rum.${awsRegion}.amazonaws.com`,
        telemetries: [
          ["errors", { stackTraceLength: 1000 }],
          "performance",
          [
            "http",
            {
              recordAllRequests: true,
              urlsToInclude: [/.*/],
              urlsToExclude: [
                /https:\/\/prod\.tools\.shortbread\.aws\.dev\/.*/,
              ],
            },
          ],
        ],
        allowCookies: false,
        enableXRay: true,
        signing: true,
      };

      if (!awsRum) {
        awsRum = new AwsRum(
          rumApplicationId,
          APPLICATION_VERSION,
          awsRegion,
          RUM_CONFIG,
        );

        window.addEventListener("error", (event) => {
          if (awsRum) {
            awsRum.recordError(event.error || new Error(event.message));
          }
        });

        window.addEventListener("unhandledrejection", (event) => {
          if (awsRum) {
            awsRum.recordError(event.reason);
          }
        });

        // Expose global function for error boundaries
        window.recordRumError = (
          error: Error,
          errorInfo?: { componentStack?: string },
        ) => {
          if (awsRum) {
            // Include component stack trace if available
            const errorWithInfo = errorInfo?.componentStack
              ? new Error(
                  `${error.message}\n\nComponent Stack:${errorInfo.componentStack}`,
                )
              : error;

            awsRum.recordError(errorWithInfo);
          }
        };
      }
    } catch (error) {
      console.error("Failed to initialize AWS RUM:", error);
    }
  }, []);

  return <div></div>;
};

export default AWSCloudWatchRealUserMointor;
